import React from 'react';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';

export const CONNECTION_STATES = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  ERROR: 'error',
};

const STATE_STYLES = {
  [CONNECTION_STATES.CONNECTED]: 'bg-green-500/20 text-green-400',
  [CONNECTION_STATES.CONNECTING]: 'bg-yellow-500/20 text-yellow-400',
};

/**
 * Hoisted connection status pill for the WebRTC dialer. Originally declared
 * inline inside the dialer's render function, which re-mounted on every render.
 */
export const ConnectionStatus = ({ connectionState, onReconnect }) => {
  const style = STATE_STYLES[connectionState] || 'bg-red-500/20 text-red-400';

  let content;
  if (connectionState === CONNECTION_STATES.CONNECTED) {
    content = (<><Wifi className="w-3 h-3" /><span>Connected</span></>);
  } else if (connectionState === CONNECTION_STATES.CONNECTING) {
    content = (<><Loader2 className="w-3 h-3 animate-spin" /><span>Connecting...</span></>);
  } else {
    content = (
      <>
        <WifiOff className="w-3 h-3" />
        <span>Disconnected</span>
        {onReconnect && (
          <button onClick={onReconnect} className="ml-1 underline" data-testid="dialer-reconnect-btn">
            Retry
          </button>
        )}
      </>
    );
  }
  return <div className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs ${style}`}>{content}</div>;
};
